import styled, { css } from 'styled-components';

const ChartsWrapper = styled.div`
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  ${({ device, directionColumn }) =>
    device === 'tablet' &&
    directionColumn &&
    css`
      align-items: center;
    `}
`;

const ChartContainer = styled.div`
  height: 240px;
  width: ${({ device, directionColumn }) =>
    device === 'desktop' || (device === 'tablet' && !directionColumn) ? 'auto' : '720px'};
  //La clase apexcharts-tooltip se usa para trasladar el tooltip del Chart
  .apexcharts-tooltip {
    transform: translateX(-4px) translateY(-48px);
  }
`;

export { ChartsWrapper, ChartContainer };
